module.exports = __webpack_public_path__ + "img/after.6ee226ee.jpg";